import { ControllerStore } from '@ayocore/platform/client/controllers/ControllerStore';
import type { LeadFunnelResult, LeadFunnelSettings } from '../common/types';

interface State {
  data: LeadFunnelResult | null;
  loading: boolean;
  error: string | null;
}

export class LeadFunnelWidgetController extends ControllerStore<State> {
  private version = 0;
  constructor(private getFunnel: (settings: LeadFunnelSettings) => Promise<LeadFunnelResult>) {
    super({ data: null, loading: true, error: null });
  }
  async load(settings: LeadFunnelSettings) {
    const version = ++this.version;
    this.setState({ data: null, loading: true, error: null });
    try {
      const data = await this.getFunnel(settings);
      if (version === this.version) this.setState({ data, loading: false });
    } catch (error) {
      if (version === this.version)
        this.setState({
          loading: false,
          error: error instanceof Error ? error.message : 'Не удалось загрузить воронку лидов',
        });
    }
  }
  cancelLoad() {
    this.version += 1;
  }
}
